import { isServer } from '@/lib/utils'
import axios, { AxiosResponse, InternalAxiosRequestConfig } from 'axios'
import qs from 'query-string'

// ------cookie
axios.defaults.withCredentials = true

const requestInterceptor = (config: InternalAxiosRequestConfig) => {
  return config
}

const responseInterceptor = (res: AxiosResponse) => {
  if (res.headers['x-wp-total']) {
    return { data: res.data, total: res.headers['x-wp-total'] }
  }
  return res.data
}

const serverApiBaseURL = process.env.SERVER_API_BASE_URL ?? 'http://kp-website-services:8080/api'

/**
 * Axios instance with error handler
 */
const ajax = axios.create({
  baseURL: isServer ? serverApiBaseURL : '/api',
  timeout: 60000,
  paramsSerializer: {
    serialize: (params) => qs.stringify(params),
  },
})

ajax.interceptors.response.use(responseInterceptor)
ajax.interceptors.request.use(requestInterceptor)

export default ajax
